"use strict";

var _classCallCheck = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _artifact = _interopRequireDefault(require("./artifact"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var PropertyTenure = /*#__PURE__*/function (_artifact$default) {
  _inherits(PropertyTenure, _artifact$default);

  var _super = _createSuper(PropertyTenure);

  function PropertyTenure(artifact) {
    var _this;

    _classCallCheck(this, PropertyTenure);

    _this = _super.call(this, artifact);
    _this.artifact.type = 'property';
    _this.artifact.subtype = 'tenure';
    return _this;
  }
  /**
   * Returns the Artifact Type (to be used before class initialization)
   * @static
   * @returns {string}
   */


  _createClass(PropertyTenure, [{
    key: "getTenureType",

    /**
     * Set Tenure Type
     * @returns {string}
     */
    value: function getTenureType() {
      return this.artifact.details.tenureType;
    }
    /**
     * Set Tenure type
     * @param {string} tenureType
     */

  }, {
    key: "setTenureType",
    value: function setTenureType(tenureType) {
      if (tenureType) {
        this.artifact.details.tenureType = tenureType;
      }
    }
    /**
     * Get Namespace
     * @returns {*}
     */

  }, {
    key: "getNamespace",
    value: function getNamespace() {
      return this.artifact.details.ns;
    }
    /**
     * Set Namespace
     * @param {string} ns
     */

  }, {
    key: "setNamespace",
    value: function setNamespace(ns) {
      if (ns) {
        this.artifact.details.ns = ns;
      }
    }
    /**
     * Get Spatial Unit
     * @returns {Array<String>}
     */

  }, {
    key: "getSpatialUnits",
    value: function getSpatialUnits() {
      return this.artifact.details.spatialUnits;
    }
    /**
     * Set Spatial Unit
     * @param {Array<string>} spatialUnits
     */

  }, {
    key: "setSpatialUnits",
    value: function setSpatialUnits(spatialUnits) {
      if (spatialUnits) {
        if (!Array.isArray(spatialUnits)) {
          throw new Error("spatialUnits must be an array");
        }

        if (spatialUnits.length > 0) {
          this.artifact.details.spatialUnits = spatialUnits;
        }
      }
    }
    /**
     * Get Modified Date
     * ISO 8601 date string
     * @returns {"string"}
     */

  }, {
    key: "getModifiedDate",
    value: function getModifiedDate() {
      return this.artifact.details.modifiedDate;
    }
    /**
     * Set Modified Date
     * ISO 8601 date string
     * @param {"string"} modifiedDate
     */

  }, {
    key: "setModifiedDate",
    value: function setModifiedDate(modifiedDate) {
      if (modifiedDate) {
        this.artifact.details.modifiedDate = modifiedDate;
      }
    }
    /**
     * Get Effective Date
     * ISO 8601 date string
     * @returns {"string"}
     */

  }, {
    key: "getEffectiveDate",
    value: function getEffectiveDate() {
      return this.artifact.details.effectiveDate;
    }
    /**
     * Set Effective Date
     * ISO 8601 date string
     * @param {"string"} effectiveDate
     */

  }, {
    key: "setEffectiveDate",
    value: function setEffectiveDate(effectiveDate) {
      if (effectiveDate) {
        this.artifact.details.effectiveDate = effectiveDate;
      }
    }
    /**
     * Get Expiration Date
     * ISO 8601 date string
     * @returns {"string"}
     */

  }, {
    key: "getExpirationDate",
    value: function getExpirationDate() {
      return this.artifact.details.expirationDate;
    }
    /**
     * Set Expiration Date
     * ISO 8601 date string
     * @param {"string"} expirationDate
     */

  }, {
    key: "setExpirationDate",
    value: function setExpirationDate(expirationDate) {
      if (expirationDate) {
        this.artifact.details.expirationDate = expirationDate;
      }
    }
    /**
     * Get Parties
     * @returns {string}
     */

  }, {
    key: "getParties",
    value: function getParties() {
      return this.details.parties;
    }
    /**
     * Set parties
     * @param {Array} parties
     */

  }, {
    key: "setParties",
    value: function setParties(parties) {
      if (parties) {
        if (!Array.isArray(parties)) {
          throw new Error("parties must be an array of objects");
        }

        if (parties.length > 0) {
          this.artifact.details.parties = [];

          var _iterator = _createForOfIteratorHelper(parties),
              _step;

          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var party = _step.value;

              if (!party.role) {
                throw new Error("Objects in parties must contain role property.");
              }

              if (!party.party) {
                throw new Error("Objects in parties must contain party property.");
              }

              this.artifact.details.parties.push({
                role: party.role,
                party: party.party
              });
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        }
      }
    }
    /**
     * Return Attributes
     * @returns {Object}
     */

  }, {
    key: "getAttributes",
    value: function getAttributes() {
      return this.artifact.details.attrs;
    }
    /**
     * Set Attributes
     * @param {Object} attrs
     */

  }, {
    key: "setAttributes",
    value: function setAttributes(attrs) {
      if (attrs) {
        this.artifact.details.attrs = {};

        for (var attr in attrs) {
          if (attrs[attr]) {
            this.artifact.details.attrs[attr] = attrs[attr];
          }
        }
      }
    }
  }], [{
    key: "getArtifactType",
    value: function getArtifactType() {
      return 'property';
    }
    /**
     * Return the Artifact Subtype (to be used before class initialization)
     * @returns {string}
     */

  }, {
    key: "getArtifactSubtype",
    value: function getArtifactSubtype() {
      return 'tenure';
    }
  }]);

  return PropertyTenure;
}(_artifact.default);

var _default = PropertyTenure;
exports.default = _default;